import React, { FC, useCallback } from 'react';
import { Tabs } from 'src/common/form/tabs';
import OrganizationLink from 'src/common/OrganizationLink';
import { DashboardLibraryTabType } from './constants';

type DashboardLibraryTabsProps = {
  activeTab: DashboardLibraryTabType;
  onChangeTab: (newTab: DashboardLibraryTabType) => any;
};

export const DashboardLibraryTabs: FC<DashboardLibraryTabsProps> = ({ activeTab, onChangeTab }) => {
  const onChange = useCallback(
    (e: any, newValue: string) => {
      onChangeTab(newValue as DashboardLibraryTabType);
    },
    [onChangeTab]
  );
  return (
    <Tabs
      theme='bedrock'
      value={activeTab}
      onChange={onChange}
      options={[
        {
          value: 'content',
          label: (
            <OrganizationLink to='/library/content' className='flex'>
              Content
            </OrganizationLink>
          ),
        },
        {
          value: 'synced-steps',
          label: (
            <OrganizationLink to='/library/synced-steps' className='flex'>
              Synced Steps
            </OrganizationLink>
          ),
        },
        {
          value: 'organization-templates',
          label: (
            <OrganizationLink to='/library/organization-templates' className='flex'>
              Organization Templates
            </OrganizationLink>
          ),
        },
      ]}
    />
  );
};
